import * as React from "react";
import { NextPageContext } from "next";

import { DarwinPageContext } from "../_app";
import CellBioDetailsPage from "../../components/pages/cell-bio-details";

const CellBioDetails = ({ uuid, tab }: { uuid: string; tab?: string }) => {
  return <CellBioDetailsPage uuid={uuid} tab={tab} />;
};

CellBioDetails.getInitialProps = async (ctx: NextPageContext & DarwinPageContext) => {
  return { uuid: ctx.query.uuid, tab: ctx.query.tab };
};

export default CellBioDetails;
